// extracted by mini-css-extract-plugin
export default {"wrapper":"Yw-z","response":"Zw-z","error":"_w-z","disabled":"ax-z","buttons":"bx-z","feedbackQuestionSection":"cx-z","yesNoWrapper":"dx-z"};